<template>
  <div>
    <div class="title">
      <span class="navigation">{{$route.meta.title}}</span>
      <span class="icon" @click="search">
        <i class="iconfont icon-sousuo1"></i>
      </span>
    </div>
    <pavilion-list @clickPavilion="BrowsePavilion"/>
  </div>
</template>

<script>
import PavilionList from "@/components/PavilionList.vue";
import { Toast } from "vant";

export default {
  components: {
    PavilionList,
    [Toast.name]: Toast
  },
  methods: {
    // search
    search() {
      this.$router.push({
        path: "/search",
        query: {
          category: "hall"
        }
      });
    },
    BrowsePavilion(item, total, page, pageSize) {
      if (item.gems.length === 0) {
        Toast("没有布置展馆");
        return;
      }
      this.$router.push({
        path: `/pavilion-view/${item.id}`
      });
    }
  }
};
</script>

<style scoped lang="less">
.title {
  position: relative;
  height: 60px;
  margin-bottom: 30px;
  .navigation {
    position: absolute;
    top: 20px;
    left: 15px;
    font-size: 24px;
    font-weight: 800;
    color: rgba(51, 51, 51, 1);
  }
  .icon {
    position: absolute;
    top: 30px;
    right: 15px;
    font-size: 20px;
  }
}
</style>